<!-- 视频、智慧场景详情 -->
<template>
  <!--视频详情-->

  <div class="c-vidoe-detail">
    <div class="back" @click="$router.back(-1)">
      <i class="el-icon-back" style="cursor:pointer"> 返回 </i>
    </div>
    <!-- <div class="c-bread-crumbs"><a href="#">机构</a> > <a href="#">智慧场景</a> > <a href="#">视屏详情</a></div> -->
    <div class="c-contant-box">
      <h2>{{title}}</h2>
      <p class="c-public-time">
        发布时间：{{videoInfo.createTime}}<br>
        发布机构：{{videoInfo.org.organization}}
      </p>
      <p class="field-box">分类：{{videoInfo.industryCategory}}</p>
      <div class="c-adg-box">
        <div v-if="videoInfo.isRedirect">
          <!-- <a :href="videoInfo.uri" target="_blank"> -->
          <div class="div1" @click="leavePage">
            <img v-bind:src="imgPreviews[0]">
            <span class="span1">{{title}}</span>
            <img class="ply-btn" src="../../assets/video/icon-play.png">
          </div>

          <!-- </a> -->
        </div>
        <div v-if="!videoInfo.isRedirect">
          <!-- <iframe frameborder="0" src="https://v.qq.com/txp/iframe/player.html?vid=n0020yrnly7" allowFullScreen="true"></iframe> -->
          <!-- <img src="../../assets/main/adg-img.png"> -->
          <video controls="controls" style="max-width: 100%;width: 100%;vertical-align: middle;" :src="videoInfo.uri"
            :poster="imgPreviews[0]"></video>
        </div>
        <div class="c-adg-txt-box">
          <div class="c-adg-left">
            <img :src="videoInfo.org.logo">
            <div class="c-adg-right-txt">
              <h3>{{videoInfo.org.organization}}</h3>
              <p>播放次数：1万+</p>
            </div>
          </div>
          <div class="c-detail-btn" @click="openOrg">查看机构</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import {
    getVideoById,getPlatformVideo
  } from '@/api/video';
  import config from '@/config/index';
  import {
    getCacheUserInfo
  } from '@/utils/auth';
  import {
    MessageBox
  } from 'element-ui';
  export default {
    name: 'VideoDetail',
    data() {
      return {
        videoInfo: {
          org: {}
        },
        vid: '',
        title: '', //            标题
        orgid: '', //            所属机构
        uploadUid: '', //        上传者
        industryCategory: '', // 分类
        industryCategoryOther: '', // 分类
        tags: '', //             标签
        profile: '', //          简介
        contacts: '', //         联系人
        mobile: '', //           手机号
        cover: '', //            封面
        uri: '', //              视频地址
        isRedirect: 0, //       是否跳转
        redirectUri: '', //      跳转地址
        show: 0, //             是否显示
        imgKeys: [],
        imgPreviews: [],
      }
    },
    computed: {
      showIndustryCategoryOther() {
        return this.industryCategory === '其他';
      },
    },
    mounted() {
      this.orgid = this.$route.query.orgid;
      this.vid = this.$route.query.vid;
      let plat = this.$route.query.plat
      if(plat=="zhibo"){
        this.getPlatform(this.vid)
      }else{
        this.queryInfo(this.vid);
      }

    },
    methods: {
      leavePage() {
        MessageBox.confirm('是否在离开页面？', '确认信息', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确认',
            cancelButtonText: '取消'
          })
          .then(() => {
            window.location.href = this.uri
          })
          .catch(action => {

          });
      },
      queryInfo(vid) {
        if (!vid) return;
        this.$http.get(getVideoById(vid)).then((res) => {
          if (res.code === 1) {
            this.videoInfo = res.data;
            this.initData();
          }
        });
      },
      getPlatform(vid){
        this.$http.get(getPlatformVideo(vid)).then(res=>{
          if (res.code === 1) {
            this.videoInfo = res.data;
            this.initData();
          }
        })
      },
      initData() {
        if (this.videoInfo) {
          const keys = Object.keys(this.videoInfo);
          keys.forEach((key) => {
            this[key] = this.videoInfo[key];
          });
          if (this.cover && typeof this.cover === 'string') {
            // console.log(this.cover)
            // let imgs = JSON.parse(this.cover);
            // this.imgKeys = imgs;
            // console.log(this.imgKeys)
            // if (imgs && imgs.length > 0) {
            //   imgs = imgs.map((img) => {
            //     return `${config.HOST_IMG}${img}`;
            //   });
            // }
            // this.imgPreviews = imgs;
            this.imgPreviews = [`${config.HOST_IMG}${this.cover}`]
          }
          this.priceDiscuss = this.nonamount === 1;
          if (this.videoInfo.org) {
            this.videoInfo.org.logo = `${config.HOST_IMG}${this.videoInfo.org.logo}`;
          } else {
            this.videoInfo.org = {};
          }
        }
      },
      openOrg() {
        // MessageBox.alert('平台功能完全开放后可查看机构详情', '平台建设中', {
        //   confirmButtonText: '确定',
        //   callback: action => {
        //     MessageBox.message({
        //       type: 'info',
        //       message: `action: ${ action }`
        //     });
        //   }
        // });
        this.$router.push('/detail/org-detail?orgid='+this.videoInfo.orgid);
      }
    }
  }
</script>

<style scoped>
  @import url(./video-detail-m.css);
  @import url(./video-detail.css);

  .div1 {
    position: relative;
    /*相对定位*/
  }

  .span1 {
    position: absolute;
    /*绝对定位*/
    width: 100%;
    top: 40%;
    left: 0;
    text-align: center;
    font-size: .5rem;
    color: white;
  }
  .ply-btn {
    position: absolute;
    width: .5rem;
    height: .5rem;
    bottom: 5%;
    left: 5%;
    text-align: center;
    font-size: .5rem;
    color: white;
  }
</style>
